let loadPromise: Promise<void> | null = null;

export function loadSpotifySDK(): Promise<void> {
  if (loadPromise) return loadPromise;

  if (window.Spotify) {
    return Promise.resolve();
  }

  loadPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://sdk.scdn.co/spotify-player.js";
    script.async = true;

    script.onerror = () => {
      loadPromise = null;
      reject(new Error("Failed to load Spotify SDK. Check ad-blockers."));
    };

    window.onSpotifyWebPlaybackSDKReady = () => {
      resolve();
    };

    document.body.appendChild(script);
  });

  return loadPromise;
}
